import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { register } from '../../auth/slice';
import { useAppDispatch, useResponsive } from '@/hooks';
import useSnackbar from '@/hooks/useSnackbar';
import img from '../../../assets/images/sign-up.png';
// import AppConfig from '@/components/AppConfig';
// import { Configs } from '@/constants/configs';

const signUpSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Muy corto')
    .max(30, 'Muy Largo')
    .required('Campo requerido'),
  lastname: Yup.string().min(2, 'Muy corto').max(30, 'Muy Largo'),
  email: Yup.string().email('Correo no válido').required('Campo requerido'),
  password: Yup.string()
    .min(2, 'Muy corto')
    .max(30, 'Muy Largo')
    .required('Campo requerido'),
});

const SignUp = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const [openSnackbar] = useSnackbar();

  const formik = useFormik({
    initialValues: { name: '', lastname: '', email: '', password: '' },
    validationSchema: signUpSchema,
    onSubmit: async ({ name, lastname, email, password }) => {
      try {
        await dispatch(register({ name, lastname, email, password }));
        navigate('/sign-up/verify-email');
      } catch (error) {
        console.error(error);
        openSnackbar('Hubo un error creando tu cuenta', 'error');
      }
    },
  });

  return (
    // <AppConfig isEnabled={Configs.ACCOUNT_CREATION}>
    <Stack
      direction={{
        xs: 'column',
        md: 'row-reverse',
      }}
      sx={{
        background: 'black',
        height: '100vh',
      }}
    >
      <Stack
        flex={{
          xs: 0,
          md: 1,
        }}
        sx={{
          background: 'black',
          backgroundImage: `url(${img})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      />
      <Stack flex={1} alignItems="center" justifyContent="center" padding={3}>
        <Paper
          sx={{
            minWidth: isMobile ? '100%' : 450,
            padding: isMobile ? 3 : 6,
            borderRadius: 6,
          }}
        >
          <Box>
            <Stack gap={2}>
              <Typography variant="h1">Registrate</Typography>
              <TextField
                name="name"
                type="text"
                label="Nombre"
                margin="normal"
                value={formik.values.name}
                onChange={formik.handleChange}
              />
              <TextField
                name="lastname"
                type="text"
                label="Apellido"
                margin="normal"
                value={formik.values.lastname}
                onChange={formik.handleChange}
              />
              <TextField
                name="email"
                type="email"
                label="Correo"
                margin="normal"
                value={formik.values.email}
                onChange={formik.handleChange}
              />
              <TextField
                name="password"
                type="password"
                label="Contraseña"
                margin="normal"
                value={formik.values.password}
                onChange={formik.handleChange}
              />
              <Button
                size="large"
                variant="contained"
                onClick={formik.handleSubmit}
              >
                Crear Cuenta
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Stack>
    </Stack>
    // </AppConfig>
  );
};

export default SignUp;
